// extracted by mini-css-extract-plugin
export default {"root":"apple-pay-button_root__Ix1Aw","black":"apple-pay-button_black__6V+Bj","white":"apple-pay-button_white__2scv+","white-outline":"apple-pay-button_white-outline__gSDVV"};